import { MatFormFieldDefaultOptions } from "@angular/material/form-field";

// Polaris TextField: the label always sits above the field (theme/mat-form-field.scss lays it out
// there), never inside it standing in for the placeholder.
export const FORM_FIELD_DEFAULT_OPTIONS: MatFormFieldDefaultOptions = { floatLabel: "always" };
